type EndDateInvalidArgs = {
  endDate?: string | null;
  startDate?: string | null;
  /** Formik `initialValues.endDate` — server value on edit, undefined when adding a user */
  initialEndDate?: string | null;
};

/**
 * Inline “End Date cannot be in the past” + submit blocking for the user modal.
 * Past-today is skipped while `endDate` is unchanged from `initialEndDate` (loaded value).
 * End before start is always enforced.
 */
export function isEndDateInvalid({ endDate, startDate, initialEndDate }: EndDateInvalidArgs): boolean {
  if (!endDate) return false;

  const endMidnight = new Date(endDate);
  endMidnight.setHours(0, 0, 0, 0);

  if (startDate) {
    const startMidnight = new Date(startDate);
    startMidnight.setHours(0, 0, 0, 0);
    if (endMidnight < startMidnight) return true;
  }

  const unchangedFromInitial = (endDate ?? null) === (initialEndDate ?? null);
  if (unchangedFromInitial) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return endMidnight < today;
}
